import { passCodes } from '../passCodes';

export const step19riddle = {
    id: 19,
    title: 'Vyšetřování',
    taskText: `
        <p>
            Odpovězte správně na všechny otázky a procvičte si mysl.
        </p>
    `,
    cipher: {
        text: `
            <p>
                Jakou barvu má veliký kříž v okolí zastávky?
            </p>
            <ol type="a">
                <li>hnědá</li>
                <li>černá</li>
                <li>modrá</li>
            </ol>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[7],
    additionalInfo: 'Odpovědí je písmeno a/b/c',
    points: true,
    hints: [
        {
            text: 'Kříž má hnědou barvu',
        },
    ],
};
